// extracted by mini-css-extract-plugin
export default {"postPage":"mFmpGg","emptyState":"vkmZxG","recentPosts":"EfqCvP","post-page--split":"jZWn9q","postPageSplit":"jZWn9q"};